import ImagesMainBannerTrackInvestmentsTrackInvestmentsBgWebp from '@/public/images/main-banner/track-investments/track-investments-bg.webp';
import ImagesMainBannerTrackInvestmentsTrackInvestmentsMainImageWebp from '@/public/images/main-banner/track-investments/track-investments-main-image.webp';

export {
  ImagesMainBannerTrackInvestmentsTrackInvestmentsBgWebp,
  ImagesMainBannerTrackInvestmentsTrackInvestmentsMainImageWebp,
};
